import type { ButtonVariants } from '@xing-com/button';

import { JobsXingletWrapper } from '../../jobs-xinglet';

export type SearchAlertsSearchAnimatedBannerProps = {
  isStickyHeader: boolean;
  empty: boolean;
  buttonVariant?: ButtonVariants;
};

export const SearchAlertsSearchAnimatedButton =
  JobsXingletWrapper<SearchAlertsSearchAnimatedBannerProps>(
    '@xing-com/crate-jobs-domain-search-alerts-search-animated-button'
  );
